import { gql } from "@apollo/client";

export const CREATE_PROGRAM_SUBTYPE = gql`
    mutation CreateProgramSubtype(
        $name: String!
        $idProgramType: Int!
         ){
        createSubtypeProgram(
            input: {
                name: $name
                idProgramType: $idProgramType
            }
        ) {
            idSubTipoPrograma
            nombre
        }
    }
`;